import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Lychrel numbers",
  "description": "",
  "published": "2012-01-27T00:00:00.000Z",
  "redirect_from": ["/blog/lychrel-numbers/swizec/3559"],
  "categories": "Algorithm, collatzconjecture, Haskell, Math, Number Theory, Palindrome, Project Euler, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last night I discovered another cool mathematical concept akin to the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Collatz_conjecture",
        "title": "Collatz conjecture"
      }}>{`Collatz conjecture`}</a>{` - `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Lychrel_numbers"
      }}>{`Lychrel numbers`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/01/300px-CollatzFractal4.png",
        "alt": "Collatz map fractal in a neighbourhood of the ...",
        "title": "Collatz map fractal in a neighbourhood of the ..."
      }}></img></p>
    <p>{`The idea of a lychrel number is pretty straightforward: Take a number, add its reverse, continue until you reach a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Palindromic_number",
        "title": "Palindromic number"
      }}>{`palindrome number`}</a>{`. If you never reach a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Palindrome",
        "title": "Palindrome"
      }}>{`palindrome`}</a>{`, then this is a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Lychrel_number",
        "title": "Lychrel number"
      }}>{`Lychrel number`}</a>{`.`}</p>
    <p>{`Something like this:`}</p>
    <blockquote>
      <p parentName="blockquote">{`349 + 943 = 1292, 1292 + 2921 = 4213 4213 + 3124 = 7337 not lychrel`}</p>
    </blockquote>
    <p>{`If you've ever done any theoretical computer science, you'll immediately spot a problem. This isn't a very good algorithm. Problem is with that "never" word in the description - an algorithm is a finite set of steps, when you need an infinite amount of steps to reach a conclusion that's ... not very useful.`}</p>
    <p>{`Honestly I am not certain what class of problems lychrel numbers fall into. The "not a lychrel number" is a half-`}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Decision_problem",
        "title": "Decision problem"
      }}>{`decidable problem`}</a>{`. It will always tell you when `}<em parentName="p">{`a number is not lychrel`}</em>{` but it will never terminate when it is. If my understanding is correct, this would make "is a lychrel number" an non-decidable problem.`}</p>
    <p><a parentName="p" {...{
        "href": "http://projecteuler.net/",
        "title": "Project Euler"
      }}>{`Project Euler`}</a>{` is kind enough to limit the problem a little bit and make it a fun algorithm to write before bed when your brain is half dead. `}<em parentName="p">{`Find all lychrel candidates under 10,000 assuming it should never take more than 50 iterations.`}</em></p>
    <p>{`Solving `}<em parentName="p">{`that`}</em>{` problem becomes rather trivial in `}<a parentName="p" {...{
        "href": "http://haskell.org",
        "title": "Haskell (programming language)"
      }}>{`Haskell`}</a>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-haskell"
      }}>{`reverse' = read . reverse . show

palindrome n = n == reverse' n

-- max denotes max recursion depth
lychrel n max
  | max <= 0 = True
  | palindrome$n+r = False
  | otherwise = lychrel (n+r) (max-1)
    where r = reverse' n

lychrels max =
  length [x | x <- [1..max], lychrel x 50]
`}</code></pre>
    <p>{`Oh and actually the first number that needs more than 50 iterations to converge into a palindrome is 10677, so the problem is pretty safely stated.`}</p>
    <p>{`For a final bit of fun, the number 4994, itself a palindrome, is a lychrel candidate.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/collatz-haskell-and-memoization/swizec/3382"
        }}>{`Collatz, Haskell and Memoization`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://flowingdata.com/2011/10/04/all-numbers-lead-to-one/"
        }}>{`All numbers lead to one`}</a>{` (flowingdata.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.livescience.com/16846-rare-date-today-10-000-years-palindrome.html"
        }}>{`Rare Date: Today Is Once-in-10,000-Years Palindrome`}</a>{` (livescience.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://mathsetc.wordpress.com/2011/07/23/problematic-views-futuring-maths/"
        }}>{`problematic views, futuring maths.`}</a>{` (mathsetc.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.msnbc.msn.com/id/45258660/ns/technology_and_science-science/"
        }}>{`Why 11/11/11 is mathematically amazing`}</a>{` (msnbc.msn.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=cdcdcc77-5738-4067-bfc8-273be2152cda",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      